// // // class FacetFiltersForm extends HTMLElement {
// // //   constructor() {
// // //     super();
// // //     this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

// // //     this.debouncedOnSubmit = debounce((event) => {
// // //       this.onSubmitHandler(event);
// // //     }, 500);

// // //     const facetForm = this.querySelector('form');
// // //     facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

// // //     const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
// // //     if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
// // //   }

// // //   static setListeners() {
// // //     const onHistoryChange = (event) => {
// // //       const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
// // //       if (searchParams === FacetFiltersForm.searchParamsPrev) return;
// // //       FacetFiltersForm.renderPage(searchParams, null, false);
// // //     }
// // //     window.addEventListener('popstate', onHistoryChange);
// // //   }

// // //   static toggleActiveFacets(disable = true) {
// // //     document.querySelectorAll('.js-facet-remove').forEach((element) => {
// // //       element.classList.toggle('disabled', disable);
// // //     });
// // //   }

// // //   static renderPage(searchParams, event, updateURLHash = true) {
// // //     FacetFiltersForm.searchParamsPrev = searchParams;
// // //     const sections = FacetFiltersForm.getSections();
// // //     const countContainer = document.getElementById('ProductCount');
// // //     const countContainerDesktop = document.getElementById('ProductCountDesktop');
// // //     document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
// // //     if (countContainer){
// // //       countContainer.classList.add('loading');
// // //     }
// // //     if (countContainerDesktop){
// // //       countContainerDesktop.classList.add('loading');
// // //     }

// // //     sections.forEach((section) => {
// // //       const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
// // //       const filterDataUrl = element => element.url === url;

// // //       FacetFiltersForm.filterData.some(filterDataUrl) ?
// // //         FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
// // //         FacetFiltersForm.renderSectionFromFetch(url, event);
// // //     });

// // //     if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
// // //   } 

// // // /*static renderPage(searchParams, event, updateURLHash = true) {
// // //     FacetFiltersForm.searchParamsPrev = searchParams;
// // //     const sections = FacetFiltersForm.getSections();
// // //     const countContainer = document.getElementById('ProductCount');
// // //     const countContainerDesktop = document.getElementById('ProductCountDesktop');
// // //     document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

// // //     if (countContainer) {
// // //         countContainer.classList.add('loading');
// // //     }
// // //     if (countContainerDesktop) {
// // //         countContainerDesktop.classList.add('loading');
// // //     }

// // //     // Mevcut URL’yi al ve analiz et
// // //     const currentUrl = new URL(window.location.href);
// // //     let baseUrl = window.location.pathname;
// // //     let queryString = currentUrl.search;

// // //     // Eğer view=custom içeriyorsa, bunu ayır ve diğer parametreleri onun yanına ekle
// // //     let newSearchParams = new URLSearchParams(searchParams);
// // //   let existingParams = new URLSearchParams(queryString);

// // //     if (queryString.includes("view=custom")) {
// // //         // "view=custom" bölümünü koruyarak, diğer parametreleri ekleyelim
// // //         baseUrl += "?view=custom";
// // //         queryString = queryString.replace("?view=custom", "").replace("&view=custom", "");
      
// // //     }

// // //     existingParams.forEach((value, key) => {
// // //         newSearchParams.set(key, value); // Yeni parametreleri var olanlarla birleştir
// // //     });

// // //     // URL’ye yeni parametreleri ekle
// // //     let finalQueryString = newSearchParams.toString();
// // //     if (finalQueryString) {
// // //         baseUrl += (baseUrl.includes("?") ? "&" : "?") + finalQueryString;
// // //     }

// // //     // Bölümleri güncelle
// // //     sections.forEach((section) => {
// // //         const url = `${baseUrl}&section_id=${section.section}`;
// // //         const filterDataUrl = element => element.url === url;

// // //         FacetFiltersForm.filterData.some(filterDataUrl) ?
// // //             FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
// // //             FacetFiltersForm.renderSectionFromFetch(url, event);
// // //     });
// // //     if (updateURLHash) FacetFiltersForm.updateURLHash(baseUrl.split("?")[1]);

// // // } */

// // //   /*biter*/

// // //   static renderSectionFromFetch(url, event) {
// // //     fetch(url)
// // //       .then(response => response.text())
// // //       .then((responseText) => {
// // //         const html = responseText;
// // //         FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
// // //         FacetFiltersForm.renderFilters(html, event);
// // //         FacetFiltersForm.renderProductGridContainer(html);
// // //         FacetFiltersForm.renderProductCount(html);
// // //       });
// // //   }

// // //   static renderSectionFromCache(filterDataUrl, event) {
// // //     const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
// // //     FacetFiltersForm.renderFilters(html, event);
// // //     FacetFiltersForm.renderProductGridContainer(html);
// // //     FacetFiltersForm.renderProductCount(html);
// // //   }

// // //   static renderProductGridContainer(html) {
// // //     document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
// // //     if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) 
// // //       loadMore();
    
// // //     colorSwatches();
// // //   }

// // //   static renderProductCount(html) {
// // //     const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
// // //     const container = document.getElementById('ProductCount');
// // //     const containerDesktop = document.getElementById('ProductCountDesktop');
// // //     container.innerHTML = count;
// // //     container.classList.remove('loading');
// // //     if (containerDesktop) {
// // //       containerDesktop.innerHTML = count;
// // //       containerDesktop.classList.remove('loading');
// // //     }
// // //   }

// // //   static renderFilters(html, event) {
// // //     const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

// // //     const facetDetailsElements =
// // //       parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
// // //     const matchesIndex = (element) => {
// // //       const jsFilter = event ? event.target.closest('.js-filter') : undefined;
// // //       return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
// // //     }
// // //     const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
// // //     const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

// // //     facetsToRender.forEach((element) => {
// // //       document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
// // //     });

// // //     FacetFiltersForm.renderActiveFacets(parsedHTML);
// // //     FacetFiltersForm.renderAdditionalElements(parsedHTML);

// // //     if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
// // //   }

// // //   static renderActiveFacets(html) {
// // //     const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

// // //     activeFacetElementSelectors.forEach((selector) => {
// // //       const activeFacetsElement = html.querySelector(selector);
// // //       if (!activeFacetsElement) return;
// // //       document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
// // //     })

// // //     FacetFiltersForm.toggleActiveFacets(false);
// // //   }

// // //   static renderAdditionalElements(html) {
// // //     const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

// // //     mobileElementSelectors.forEach((selector) => {
// // //       if (!html.querySelector(selector)) return;
// // //       document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
// // //     });

// // //     document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
// // //   }

// // //   static renderCounts(source, target) {
// // //     const targetElement = target.querySelector('.facets__selected');
// // //     const sourceElement = source.querySelector('.facets__selected');

// // //     const targetElementAccessibility = target.querySelector('.facets__summary');
// // //     const sourceElementAccessibility = source.querySelector('.facets__summary');

// // //     if (sourceElement && targetElement) {
// // //       target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
// // //     }

// // //     if (targetElementAccessibility && sourceElementAccessibility) {
// // //       target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
// // //     }
// // //   }

// // //   static updateURLHash(searchParams) {
// // //     history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
// // //   }

// // //   static getSections() {
// // //     return [
// // //       {
// // //         section: document.getElementById('product-grid').dataset.id,
// // //       }
// // //     ]
// // //   }

// // //   createSearchParams(form) {
// // //     const formData = new FormData(form);
// // //     return new URLSearchParams(formData).toString();
// // //   }

// // //   onSubmitForm(searchParams, event) {
// // //     FacetFiltersForm.renderPage(searchParams, event);
// // //   }

// // //   onSubmitHandler(event) {
// // //     event.preventDefault();
// // //     const sortFilterForms = document.querySelectorAll('facet-filters-form form');
// // //     if (event.srcElement.className == 'mobile-facets__checkbox') {
// // //       const searchParams = this.createSearchParams(event.target.closest('form'))
// // //       this.onSubmitForm(searchParams, event)
// // //     } else {
// // //       const forms = [];
// // //       const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

// // //       sortFilterForms.forEach((form) => {
// // //         if (!isMobile) {
// // //           if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
// // //             const noJsElements = document.querySelectorAll('.no-js-list');
// // //             noJsElements.forEach((el) => el.remove());
// // //             forms.push(this.createSearchParams(form));
// // //           }
// // //         } else if (form.id === 'FacetFiltersFormMobile') {
// // //           forms.push(this.createSearchParams(form));
// // //         }
// // //       });
// // //       this.onSubmitForm(forms.join('&'), event)
// // //     }
// // //   }

// // //   onActiveFilterClick(event) {
// // //     event.preventDefault();
// // //     FacetFiltersForm.toggleActiveFacets();
// // //     const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
// // //     FacetFiltersForm.renderPage(url);
// // //   }
// // // }

// // // FacetFiltersForm.filterData = [];
// // // FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
// // // FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
// // // customElements.define('facet-filters-form', FacetFiltersForm);
// // // FacetFiltersForm.setListeners();

// // // class PriceRange extends HTMLElement {
// // //   constructor() {
// // //     super();
// // //     this.querySelectorAll('input')
// // //       .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
// // //     this.setMinAndMaxValues();
// // //     this.controlSlider();
// // //     this.controlInput();
// // //   }

// // //   onRangeChange(event) {
// // //     this.adjustToValidValues(event.currentTarget);
// // //     this.setMinAndMaxValues();
// // //   }

// // //   setMinAndMaxValues() {
// // //     const inputs = this.querySelectorAll('input');
// // //     const minInput = inputs[0];
// // //     const maxInput = inputs[1];
// // //     if (maxInput.value) minInput.setAttribute('max', maxInput.value);
// // //     if (minInput.value) maxInput.setAttribute('min', minInput.value);
// // //     if (minInput.value === '') maxInput.setAttribute('min', 0);
// // //     if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
// // //   }

// // //   adjustToValidValues(input) {
// // //     const value = Number(input.value);
// // //     const min = Number(input.getAttribute('min'));
// // //     const max = Number(input.getAttribute('max'));

// // //     if (value < min) input.value = min;
// // //     if (value > max) input.value = max;
// // //   }

// // //   fillSlider () {
// // //     const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
// // //     inputRangeWrappers.forEach(inputWrapper => {
// // //       const inputsRange = inputWrapper.querySelectorAll('.field__range');
// // //       const inputRangeFrom = inputsRange[0];
// // //       const inputRangeTo = inputsRange[1];

// // //       const range = inputRangeTo.max - inputRangeTo.min;
// // //       const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
// // //       const toCurrent = inputRangeTo.value - inputRangeTo.min;
// // //       const minRange = fromCurrent / range * 100;
// // //       const maxRange = toCurrent / range * 100;

// // //       inputWrapper.setAttribute(
// // //         'style',
// // //         `--range-min: ${minRange}%; --range-max: ${maxRange}%`
// // //       );
// // //     })
// // //   }

// // //   controlSlider () {
// // //     const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
// // //     const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

// // //     inputRangeWrappers.forEach((inputWrapper, index) => {
// // //       const inputsRange = inputWrapper.querySelectorAll('.field__range');
// // //       const inputRangeFrom = inputsRange[0];
// // //       const inputRangeTo = inputsRange[1];
// // //       const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('.field__input')[0];
// // //       const inputNumberTo = inputNumberWrappers[index].querySelectorAll('.field__input')[1];

// // //       inputRangeFrom.oninput = () => {
// // //         const from = parseInt(inputRangeFrom.value, 10);
// // //         const to = parseInt(inputRangeTo.value, 10);
// // //         if (from > to) {
// // //           inputRangeFrom.value = to;
// // //           inputNumberFrom.value = to;
// // //         }
// // //         else {
// // //           inputNumberFrom.value = from;
// // //         }

// // //         this.fillSlider();
// // //       }

// // //       if (Number(inputRangeTo.value) <= 0 ) {
// // //         inputRangeTo.style.zIndex = 2;
// // //       } else {
// // //         inputRangeTo.style.zIndex = 0;
// // //       }

// // //       inputRangeTo.oninput = () => {
// // //         const from = parseInt(inputRangeFrom.value, 10);
// // //         const to = parseInt(inputRangeTo.value, 10);
// // //         if (from <= to) {
// // //           inputRangeTo.value = to;
// // //           inputNumberTo.value = to;
// // //         }
// // //         else {
// // //           inputNumberTo.value = from;
// // //           inputRangeTo.value = from;
// // //         }

// // //         if (Number(inputRangeTo.value) <= 0 ) {
// // //           inputRangeTo.style.zIndex = 2;
// // //         } else {
// // //           inputRangeTo.style.zIndex = 0;
// // //         }

// // //         this.fillSlider();
// // //       }
// // //     })
// // //   }

// // //   controlInput() {
// // //     const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
// // //     const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

// // //     inputNumberWrappers.forEach((inputWrapper, index) => {
// // //       const inputsNumber = inputWrapper.querySelectorAll('.field__input');
// // //       const inputNumberFrom = inputsNumber[0];
// // //       const inputNumberTo = inputsNumber[1];
// // //       const inputRangeFrom = inputRangeWrappers[index].querySelectorAll('.field__range')[0];
// // //       const inputRangeTo = inputRangeWrappers[index].querySelectorAll('.field__range')[1];

// // //       inputNumberFrom.oninput = () => {
// // //         const from = parseInt(inputNumberFrom.value, 10);
// // //         const to = parseInt(inputNumberTo.value, 10);
// // //         if (from > to) {
// // //           inputRangeFrom.value = to;
// // //           inputNumberFrom.value = to;
// // //         } 
// // //         else {
// // //           inputRangeFrom.value = from;
// // //         }

// // //         this.fillSlider();
// // //       }

// // //       inputNumberTo.oninput = () => {
// // //         const from = parseInt(inputNumberFrom.value, 10);
// // //         const to = parseInt(inputNumberTo.value, 10);
// // //         if (from <= to) {
// // //           inputRangeTo.value = to;
// // //           inputNumberTo.value = to;
// // //         }
// // //         else {
// // //           inputNumberTo.value = from;
// // //         }

// // //         this.fillSlider();
// // //       }

// // //     })
// // //   }
// // // }

// // // customElements.define('price-range', PriceRange);

// // // class FacetRemove extends HTMLElement {
// // //   constructor() {
// // //     super();
// // //     const facetLink = this.querySelector('a');
// // //     facetLink.setAttribute('role', 'button');
// // //     facetLink.addEventListener('click', this.closeFilter.bind(this));
// // //     facetLink.addEventListener('keyup', (event) => {
// // //       event.preventDefault();
// // //       if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
// // //     });
// // //   }

// // //   closeFilter(event) {
// // //     event.preventDefault();
// // //     const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
// // //     form.onActiveFilterClick(event);
// // //   }
// // // }

// // // customElements.define('facet-remove', FacetRemove);
// // class FacetFiltersForm extends HTMLElement {
// //   constructor() {
// //     super();
// //     this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

// //     this.debouncedOnSubmit = debounce((event) => {
// //       this.onSubmitHandler(event);
// //     }, 500);

// //     const facetForm = this.querySelector('form');
// //     facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

// //     const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
// //     if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
// //   }

// //   static setListeners() {
// //     const onHistoryChange = (event) => {
// //       const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
// //       if (searchParams === FacetFiltersForm.searchParamsPrev) return;
// //       FacetFiltersForm.renderPage(searchParams, null, false);
// //     }
// //     window.addEventListener('popstate', onHistoryChange);
// //   }

// //   static toggleActiveFacets(disable = true) {
// //     document.querySelectorAll('.js-facet-remove').forEach((element) => {
// //       element.classList.toggle('disabled', disable);
// //     });
// //   }

// //   static renderPage(searchParams, event, updateURLHash = true) {
// //     FacetFiltersForm.searchParamsPrev = searchParams;
// //     const sections = FacetFiltersForm.getSections();
// //     const countContainer = document.getElementById('ProductCount');
// //     const countContainerDesktop = document.getElementById('ProductCountDesktop');
// //     document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
// //     if (countContainer){
// //       countContainer.classList.add('loading');
// //     }
// //     if (countContainerDesktop){
// //       countContainerDesktop.classList.add('loading');
// //     }

// //     sections.forEach((section) => {
// //       const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
// //       const filterDataUrl = element => element.url === url;

// //       FacetFiltersForm.filterData.some(filterDataUrl) ?
// //         FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
// //         FacetFiltersForm.renderSectionFromFetch(url, event);
// //     });

// //     if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
// //   } 

// // /*static renderPage(searchParams, event, updateURLHash = true) {
// //     FacetFiltersForm.searchParamsPrev = searchParams;
// //     const sections = FacetFiltersForm.getSections();
// //     const countContainer = document.getElementById('ProductCount');
// //     const countContainerDesktop = document.getElementById('ProductCountDesktop');
// //     document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

// //     if (countContainer) {
// //         countContainer.classList.add('loading');
// //     }
// //     if (countContainerDesktop) {
// //         countContainerDesktop.classList.add('loading');
// //     }

// //     // Mevcut URL’yi al ve analiz et
// //     const currentUrl = new URL(window.location.href);
// //     let baseUrl = window.location.pathname;
// //     let queryString = currentUrl.search;

// //     // Eğer view=custom içeriyorsa, bunu ayır ve diğer parametreleri onun yanına ekle
// //     let newSearchParams = new URLSearchParams(searchParams);
// //   let existingParams = new URLSearchParams(queryString);

// //     if (queryString.includes("view=custom")) {
// //         // "view=custom" bölümünü koruyarak, diğer parametreleri ekleyelim
// //         baseUrl += "?view=custom";
// //         queryString = queryString.replace("?view=custom", "").replace("&view=custom", "");
      
// //     }

// //     existingParams.forEach((value, key) => {
// //         newSearchParams.set(key, value); // Yeni parametreleri var olanlarla birleştir
// //     });

// //     // URL’ye yeni parametreleri ekle
// //     let finalQueryString = newSearchParams.toString();
// //     if (finalQueryString) {
// //         baseUrl += (baseUrl.includes("?") ? "&" : "?") + finalQueryString;
// //     }

// //     // Bölümleri güncelle
// //     sections.forEach((section) => {
// //         const url = `${baseUrl}&section_id=${section.section}`;
// //         const filterDataUrl = element => element.url === url;

// //         FacetFiltersForm.filterData.some(filterDataUrl) ?
// //             FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
// //             FacetFiltersForm.renderSectionFromFetch(url, event);
// //     });
// //     if (updateURLHash) FacetFiltersForm.updateURLHash(baseUrl.split("?")[1]);

// // } */

// //   /*biter*/

// //   static renderSectionFromFetch(url, event) {
// //     fetch(url)
// //       .then(response => response.text())
// //       .then((responseText) => {
// //         const html = responseText;
// //         FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
// //         FacetFiltersForm.renderFilters(html, event);
// //         FacetFiltersForm.renderProductGridContainer(html);
// //         FacetFiltersForm.renderProductCount(html);
// //       });
// //   }

// //   static renderSectionFromCache(filterDataUrl, event) {
// //     const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
// //     FacetFiltersForm.renderFilters(html, event);
// //     FacetFiltersForm.renderProductGridContainer(html);
// //     FacetFiltersForm.renderProductCount(html);
// //   }

// //   static renderProductGridContainer(html) {
// //     document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
// //     if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) 
// //       loadMore();
    
// //     colorSwatches();
// //   }

// //   static renderProductCount(html) {
// //     const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
// //     const countElement = parsedHtml.getElementById('ProductCount');
// //     if (!countElement) return;

// //     const count = countElement.innerHTML;
// //     const container = document.getElementById('ProductCount');
// //     const containerDesktop = document.getElementById('ProductCountDesktop');

// //     if (container) {
// //       container.innerHTML = count;
// //       container.classList.remove('loading');
// //     }
// //     if (containerDesktop) {
// //       containerDesktop.innerHTML = count;
// //       containerDesktop.classList.remove('loading');
// //     }
// //   }

// //   static renderFilters(html, event) {
// //     const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

// //     const facetDetailsElements =
// //       parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
// //     const matchesIndex = (element) => {
// //       const jsFilter = event ? event.target.closest('.js-filter') : undefined;
// //       return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
// //     }
// //     const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
// //     const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

// //     facetsToRender.forEach((element) => {
// //       document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
// //     });

// //     FacetFiltersForm.renderActiveFacets(parsedHTML);
// //     FacetFiltersForm.renderAdditionalElements(parsedHTML);

// //     if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
// //   }

// //   static renderActiveFacets(html) {
// //     const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

// //     activeFacetElementSelectors.forEach((selector) => {
// //       const activeFacetsElement = html.querySelector(selector);
// //       if (!activeFacetsElement) return;
// //       document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
// //     })

// //     FacetFiltersForm.toggleActiveFacets(false);
// //   }

// //   static renderAdditionalElements(html) {
// //     const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

// //     mobileElementSelectors.forEach((selector) => {
// //       if (!html.querySelector(selector)) return;
// //       document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
// //     });

// //     const mobileForm = document.getElementById('FacetFiltersFormMobile');
// //     if (mobileForm) {
// //       const menuDrawer = mobileForm.closest('menu-drawer');
// //       if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
// //         menuDrawer.bindEvents();
// //       }
// //     }
// //   }

// //   static renderCounts(source, target) {
// //     const targetElement = target.querySelector('.facets__selected');
// //     const sourceElement = source.querySelector('.facets__selected');

// //     const targetElementAccessibility = target.querySelector('.facets__summary');
// //     const sourceElementAccessibility = source.querySelector('.facets__summary');

// //     if (sourceElement && targetElement) {
// //       target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
// //     }

// //     if (targetElementAccessibility && sourceElementAccessibility) {
// //       target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
// //     }
// //   }

// //   static updateURLHash(searchParams) {
// //     history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
// //   }

// //   static getSections() {
// //     return [
// //       {
// //         section: document.getElementById('product-grid').dataset.id,
// //       }
// //     ]
// //   }

// //   createSearchParams(form) {
// //     const formData = new FormData(form);
// //     return new URLSearchParams(formData).toString();
// //   }

// //   onSubmitForm(searchParams, event) {
// //     FacetFiltersForm.renderPage(searchParams, event);
// //   }

// //   onSubmitHandler(event) {
// //     event.preventDefault();
// //     const sortFilterForms = document.querySelectorAll('facet-filters-form form');
// //     if (event.srcElement.className == 'mobile-facets__checkbox') {
// //       const searchParams = this.createSearchParams(event.target.closest('form'))
// //       this.onSubmitForm(searchParams, event)
// //     } else {
// //       const forms = [];
// //       const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

// //       sortFilterForms.forEach((form) => {
// //         if (!isMobile) {
// //           if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
// //             const noJsElements = document.querySelectorAll('.no-js-list');
// //             noJsElements.forEach((el) => el.remove());
// //             forms.push(this.createSearchParams(form));
// //           }
// //         } else if (form.id === 'FacetFiltersFormMobile') {
// //           forms.push(this.createSearchParams(form));
// //         }
// //       });
// //       this.onSubmitForm(forms.join('&'), event)
// //     }
// //   }

// //   onActiveFilterClick(event) {
// //     event.preventDefault();
// //     FacetFiltersForm.toggleActiveFacets();
// //     const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
// //     FacetFiltersForm.renderPage(url);
// //   }
// // }

// // FacetFiltersForm.filterData = [];
// // FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
// // FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
// // customElements.define('facet-filters-form', FacetFiltersForm);
// // FacetFiltersForm.setListeners();

// // class PriceRange extends HTMLElement {
// //   constructor() {
// //     super();
// //     this.querySelectorAll('input')
// //       .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
// //     this.setMinAndMaxValues();
// //     this.controlSlider();
// //     this.controlInput();
// //   }

// //   onRangeChange(event) {
// //     this.adjustToValidValues(event.currentTarget);
// //     this.setMinAndMaxValues();
// //   }

// //   setMinAndMaxValues() {
// //     const inputs = this.querySelectorAll('input');
// //     const minInput = inputs[0];
// //     const maxInput = inputs[1];
// //     if (maxInput.value) minInput.setAttribute('max', maxInput.value);
// //     if (minInput.value) maxInput.setAttribute('min', minInput.value);
// //     if (minInput.value === '') maxInput.setAttribute('min', 0);
// //     if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
// //   }

// //   adjustToValidValues(input) {
// //     const value = Number(input.value);
// //     const min = Number(input.getAttribute('min'));
// //     const max = Number(input.getAttribute('max'));

// //     if (value < min) input.value = min;
// //     if (value > max) input.value = max;
// //   }

// //   fillSlider () {
// //     const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
// //     inputRangeWrappers.forEach(inputWrapper => {
// //       const inputsRange = inputWrapper.querySelectorAll('.field__range');
// //       const inputRangeFrom = inputsRange[0];
// //       const inputRangeTo = inputsRange[1];

// //       const range = inputRangeTo.max - inputRangeTo.min;
// //       const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
// //       const toCurrent = inputRangeTo.value - inputRangeTo.min;
// //       const minRange = fromCurrent / range * 100;
// //       const maxRange = toCurrent / range * 100;

// //       inputWrapper.setAttribute(
// //         'style',
// //         `--range-min: ${minRange}%; --range-max: ${maxRange}%`
// //       );
// //     })
// //   }

// //   controlSlider () {
// //     const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
// //     const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

// //     inputRangeWrappers.forEach((inputWrapper, index) => {
// //       const inputsRange = inputWrapper.querySelectorAll('.field__range');
// //       const inputRangeFrom = inputsRange[0];
// //       const inputRangeTo = inputsRange[1];
// //       const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('.field__input')[0];
// //       const inputNumberTo = inputNumberWrappers[index].querySelectorAll('.field__input')[1];

// //       inputRangeFrom.oninput = () => {
// //         const from = parseInt(inputRangeFrom.value, 10);
// //         const to = parseInt(inputRangeTo.value, 10);
// //         if (from > to) {
// //           inputRangeFrom.value = to;
// //           inputNumberFrom.value = to;
// //         }
// //         else {
// //           inputNumberFrom.value = from;
// //         }

// //         this.fillSlider();
// //       }

// //       if (Number(inputRangeTo.value) <= 0 ) {
// //         inputRangeTo.style.zIndex = 2;
// //       } else {
// //         inputRangeTo.style.zIndex = 0;
// //       }

// //       inputRangeTo.oninput = () => {
// //         const from = parseInt(inputRangeFrom.value, 10);
// //         const to = parseInt(inputRangeTo.value, 10);
// //         if (from <= to) {
// //           inputRangeTo.value = to;
// //           inputNumberTo.value = to;
// //         }
// //         else {
// //           inputNumberTo.value = from;
// //           inputRangeTo.value = from;
// //         }

// //         if (Number(inputRangeTo.value) <= 0 ) {
// //           inputRangeTo.style.zIndex = 2;
// //         } else {
// //           inputRangeTo.style.zIndex = 0;
// //         }

// //         this.fillSlider();
// //       }
// //     })
// //   }

// //   controlInput() {
// //     const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
// //     const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

// //     inputNumberWrappers.forEach((inputWrapper, index) => {
// //       const inputsNumber = inputWrapper.querySelectorAll('.field__input');
// //       const inputNumberFrom = inputsNumber[0];
// //       const inputNumberTo = inputsNumber[1];
// //       const inputRangeFrom = inputRangeWrappers[index].querySelectorAll('.field__range')[0];
// //       const inputRangeTo = inputRangeWrappers[index].querySelectorAll('.field__range')[1];

// //       inputNumberFrom.oninput = () => {
// //         const from = parseInt(inputNumberFrom.value, 10);
// //         const to = parseInt(inputNumberTo.value, 10);
// //         if (from > to) {
// //           inputRangeFrom.value = to;
// //           inputNumberFrom.value = to;
// //         } 
// //         else {
// //           inputRangeFrom.value = from;
// //         }

// //         this.fillSlider();
// //       }

// //       inputNumberTo.oninput = () => {
// //         const from = parseInt(inputNumberFrom.value, 10);
// //         const to = parseInt(inputNumberTo.value, 10);
// //         if (from <= to) {
// //           inputRangeTo.value = to;
// //           inputNumberTo.value = to;
// //         }
// //         else {
// //           inputNumberTo.value = from;
// //         }

// //         this.fillSlider();
// //       }

// //     })
// //   }
// // }

// // customElements.define('price-range', PriceRange);

// // class FacetRemove extends HTMLElement {
// //   constructor() {
// //     super();
// //     const facetLink = this.querySelector('a');
// //     facetLink.setAttribute('role', 'button');
// //     facetLink.addEventListener('click', this.closeFilter.bind(this));
// //     facetLink.addEventListener('keyup', (event) => {
// //       event.preventDefault();
// //       if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
// //     });
// //   }

// //   closeFilter(event) {
// //     event.preventDefault();
// //     const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
// //     form.onActiveFilterClick(event);
// //   }
// // }

// // customElements.define('facet-remove', FacetRemove);
// class FacetFiltersForm extends HTMLElement {
//   constructor() {
//     super();
//     this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

//     this.debouncedOnSubmit = debounce((event) => {
//       this.onSubmitHandler(event);
//     }, 500);

//     const facetForm = this.querySelector('form');
//     facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

//     // Immediate visual feedback for checkboxes
//     facetForm.addEventListener('change', (event) => {
//       if (event.target.type === 'checkbox') {
//         // Sync same-named checkboxes across all forms immediately
//         const paramName = event.target.name;
//         const paramValue = event.target.value;
//         const isChecked = event.target.checked;

//         document.querySelectorAll(`input[type="checkbox"][name="${paramName}"][value="${paramValue}"]`).forEach(checkbox => {
//           if (checkbox !== event.target) {
//             checkbox.checked = isChecked;
//           }
//         });
//       }
//     });

//     // Price display input sync with hidden input
//     this.initPriceInputSync();

//     const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
//     if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
//   }
//   openDetailsOnWideScreen() {
//     // Check if on desktop (>768px)
//     const mediaQuery = window.matchMedia('(min-width: 769px)');
    
//     const openAllDetails = () => {
//       if (mediaQuery.matches) {
//         // Desktop: open all details
//         this.querySelectorAll('details.disclosure-has-popup.facets__disclosure').forEach(detail => {
//           detail.setAttribute('open', '');
//         });
//       } else {
//         // Mobile: close all details
//         this.querySelectorAll('details.disclosure-has-popup.facets__disclosure').forEach(detail => {
//           detail.removeAttribute('open');
//         });
//       }
//     };

//     // Initial check
//     openAllDetails();

//     // Listen for window resize
//     mediaQuery.addListener(openAllDetails);
//   }

//   initPriceInputSync() {
//     const priceDisplayInputs = this.querySelectorAll('.price-display-input');
//     priceDisplayInputs.forEach(input => {
//       input.addEventListener('input', (e) => {
//         // Find hidden input - it should be a sibling or in the same parent
//         let hiddenInput = e.target.parentElement.querySelector('.price-hidden-input');
//         if (!hiddenInput) {
//           // If not in parent, check next element or look in price-range element
//           hiddenInput = e.target.closest('price-range').querySelector(`.price-hidden-input[name="${e.target.dataset.paramName}"]`);
//         }
//         if (hiddenInput) {
//           // Convert display value (dollars) to cents for Shopify
//           const displayValue = parseFloat(e.target.value) || 0;
//           hiddenInput.value = Math.round(displayValue * 100);
//         }
//       });
//     });
//   }

//   static setListeners() {
//     const onHistoryChange = (event) => {
//       const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
//       if (searchParams === FacetFiltersForm.searchParamsPrev) return;
//       FacetFiltersForm.renderPage(searchParams, null, false);
//     }
//     window.addEventListener('popstate', onHistoryChange);
//   }

//   static toggleActiveFacets(disable = true) {
//     document.querySelectorAll('.js-facet-remove').forEach((element) => {
//       element.classList.toggle('disabled', disable);
//     });
//   }

//   static renderPage(searchParams, event, updateURLHash = true) {
//     FacetFiltersForm.searchParamsPrev = searchParams;
//     const sections = FacetFiltersForm.getSections();
//     const countContainer = document.getElementById('ProductCount');
//     const countContainerDesktop = document.getElementById('ProductCountDesktop');
//     document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
//     if (countContainer){
//       countContainer.classList.add('loading');
//     }
//     if (countContainerDesktop){
//       countContainerDesktop.classList.add('loading');
//     }

//     sections.forEach((section) => {
//       const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
//       const filterDataUrl = element => element.url === url;

//       FacetFiltersForm.filterData.some(filterDataUrl) ?
//         FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
//         FacetFiltersForm.renderSectionFromFetch(url, event);
//     });

//     if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
//   } 

// /*static renderPage(searchParams, event, updateURLHash = true) {
//     FacetFiltersForm.searchParamsPrev = searchParams;
//     const sections = FacetFiltersForm.getSections();
//     const countContainer = document.getElementById('ProductCount');
//     const countContainerDesktop = document.getElementById('ProductCountDesktop');
//     document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

//     if (countContainer) {
//         countContainer.classList.add('loading');
//     }
//     if (countContainerDesktop) {
//         countContainerDesktop.classList.add('loading');
//     }

//     // Mevcut URL’yi al ve analiz et
//     const currentUrl = new URL(window.location.href);
//     let baseUrl = window.location.pathname;
//     let queryString = currentUrl.search;

//     // Eğer view=custom içeriyorsa, bunu ayır ve diğer parametreleri onun yanına ekle
//     let newSearchParams = new URLSearchParams(searchParams);
//   let existingParams = new URLSearchParams(queryString);

//     if (queryString.includes("view=custom")) {
//         // "view=custom" bölümünü koruyarak, diğer parametreleri ekleyelim
//         baseUrl += "?view=custom";
//         queryString = queryString.replace("?view=custom", "").replace("&view=custom", "");
      
//     }

//     existingParams.forEach((value, key) => {
//         newSearchParams.set(key, value); // Yeni parametreleri var olanlarla birleştir
//     });

//     // URL’ye yeni parametreleri ekle
//     let finalQueryString = newSearchParams.toString();
//     if (finalQueryString) {
//         baseUrl += (baseUrl.includes("?") ? "&" : "?") + finalQueryString;
//     }

//     // Bölümleri güncelle
//     sections.forEach((section) => {
//         const url = `${baseUrl}&section_id=${section.section}`;
//         const filterDataUrl = element => element.url === url;

//         FacetFiltersForm.filterData.some(filterDataUrl) ?
//             FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
//             FacetFiltersForm.renderSectionFromFetch(url, event);
//     });
//     if (updateURLHash) FacetFiltersForm.updateURLHash(baseUrl.split("?")[1]);

// } */

//   /*biter*/

//   static renderSectionFromFetch(url, event) {
//     fetch(url)
//       .then(response => response.text())
//       .then((responseText) => {
//         const html = responseText;
//         FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
//         FacetFiltersForm.renderFilters(html, event);
//         FacetFiltersForm.renderProductGridContainer(html);
//         FacetFiltersForm.renderProductCount(html);
//       });
//   }

//   static renderSectionFromCache(filterDataUrl, event) {
//     const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
//     FacetFiltersForm.renderFilters(html, event);
//     FacetFiltersForm.renderProductGridContainer(html);
//     FacetFiltersForm.renderProductCount(html);
//   }

//   static renderProductGridContainer(html) {
//     document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
//     if (document.querySelector('.js-load-more') || document.querySelector('.js-infinite-scroll')) 
//       loadMore();
    
//     colorSwatches();
//   }

//   static renderProductCount(html) {
//     const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
//     const countElement = parsedHtml.getElementById('ProductCount');
//     if (!countElement) return;

//     const count = countElement.innerHTML;
//     const container = document.getElementById('ProductCount');
//     const containerDesktop = document.getElementById('ProductCountDesktop');

//     if (container) {
//       container.innerHTML = count;
//       container.classList.remove('loading');
//     }
//     if (containerDesktop) {
//       containerDesktop.innerHTML = count;
//       containerDesktop.classList.remove('loading');
//     }
//   }

//   static renderFilters(html, event) {
//     const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

//     const facetDetailsElements =
//       parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
//     const matchesIndex = (element) => {
//       const jsFilter = event ? event.target.closest('.js-filter') : undefined;
//       return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
//     }
//     const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
//     const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

//     // Update all matching elements (both desktop and mobile)
//     facetsToRender.forEach((element) => {
//       const matchingElements = document.querySelectorAll(`.js-filter[data-index="${element.dataset.index}"]`);
//       matchingElements.forEach((targetElement) => {
//         targetElement.innerHTML = element.innerHTML;
//       });
//     });

//     // Re-initialize price input sync after DOM update
//     FacetFiltersForm.reinitPriceInputSync();

//     FacetFiltersForm.renderActiveFacets(parsedHTML);
//     FacetFiltersForm.renderAdditionalElements(parsedHTML);

//     if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
//   }

//   static reinitPriceInputSync() {
//     document.querySelectorAll('facet-filters-form').forEach(form => {
//       const priceDisplayInputs = form.querySelectorAll('.price-display-input');
//       priceDisplayInputs.forEach(input => {
//         // Remove old listeners by cloning
//         const newInput = input.cloneNode(true);
//         input.parentNode.replaceChild(newInput, input);

//         newInput.addEventListener('input', (e) => {
//           // Find hidden input - it should be a sibling or in the same parent
//           let hiddenInput = e.target.parentElement.querySelector('.price-hidden-input');
//           if (!hiddenInput) {
//             // If not in parent, check in price-range element
//             hiddenInput = e.target.closest('price-range').querySelector(`.price-hidden-input[name="${e.target.dataset.paramName}"]`);
//           }
//           if (hiddenInput) {
//             const displayValue = parseFloat(e.target.value) || 0;
//             hiddenInput.value = Math.round(displayValue * 100);
//           }
//         });
//       });
//     });
//   }

//   static renderActiveFacets(html) {
//     const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

//     activeFacetElementSelectors.forEach((selector) => {
//       const activeFacetsElement = html.querySelector(selector);
//       if (!activeFacetsElement) return;
//       document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
//     })

//     FacetFiltersForm.toggleActiveFacets(false);
//   }

//   static renderAdditionalElements(html) {
//     const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

//     mobileElementSelectors.forEach((selector) => {
//       if (!html.querySelector(selector)) return;
//       document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
//     });

//     const mobileForm = document.getElementById('FacetFiltersFormMobile');
//     if (mobileForm) {
//       const menuDrawer = mobileForm.closest('menu-drawer');
//       if (menuDrawer && typeof menuDrawer.bindEvents === 'function') {
//         menuDrawer.bindEvents();
//       }
//     }
//   }

//   static renderCounts(source, target) {
//     const targetElement = target.querySelector('.facets__selected');
//     const sourceElement = source.querySelector('.facets__selected');

//     const targetElementAccessibility = target.querySelector('.facets__summary');
//     const sourceElementAccessibility = source.querySelector('.facets__summary');

//     if (sourceElement && targetElement) {
//       target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
//     }

//     if (targetElementAccessibility && sourceElementAccessibility) {
//       target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
//     }
//   }

//   static updateURLHash(searchParams) {
//     history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
//   }

//   static getSections() {
//     return [
//       {
//         section: document.getElementById('product-grid').dataset.id,
//       }
//     ]
//   }

//   createSearchParams(form) {
//     const formData = new FormData(form);
//     return new URLSearchParams(formData).toString();
//   }

//   onSubmitForm(searchParams, event) {
//     FacetFiltersForm.renderPage(searchParams, event);
//   }

//   onSubmitHandler(event) {
//     event.preventDefault();
//     const sortFilterForms = document.querySelectorAll('facet-filters-form form');
//     if (event.srcElement.className == 'mobile-facets__checkbox') {
//       const searchParams = this.createSearchParams(event.target.closest('form'))
//       this.onSubmitForm(searchParams, event)
//     } else {
//       const forms = [];
//       const currentFormId = event.target.closest('form').id;
//       const isMobile = currentFormId === 'FacetFiltersFormMobile';

//       sortFilterForms.forEach((form) => {
//         if (!isMobile) {
//           if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm' || form.id === 'FacetFiltersFormDesktop') {
//             const noJsElements = document.querySelectorAll('.no-js-list');
//             noJsElements.forEach((el) => el.remove());
//             forms.push(this.createSearchParams(form));
//           }
//         } else if (form.id === 'FacetFiltersFormMobile') {
//           forms.push(this.createSearchParams(form));
//         }
//       });
//       this.onSubmitForm(forms.join('&'), event)
//     }
//   }

//   onActiveFilterClick(event) {
//     event.preventDefault();
//     FacetFiltersForm.toggleActiveFacets();
//     const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
//     FacetFiltersForm.renderPage(url);
//   }
// }

// FacetFiltersForm.filterData = [];
// FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
// FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
// customElements.define('facet-filters-form', FacetFiltersForm);
// FacetFiltersForm.setListeners();

// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.querySelectorAll('input')
//       .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
//     this.setMinAndMaxValues();
//     this.controlSlider();
//     this.controlInput();
//   }

//   onRangeChange(event) {
//     this.adjustToValidValues(event.currentTarget);
//     this.setMinAndMaxValues();
//   }

//   setMinAndMaxValues() {
//     const inputs = this.querySelectorAll('input');
//     const minInput = inputs[0];
//     const maxInput = inputs[1];
//     if (maxInput.value) minInput.setAttribute('max', maxInput.value);
//     if (minInput.value) maxInput.setAttribute('min', minInput.value);
//     if (minInput.value === '') maxInput.setAttribute('min', 0);
//     if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
//   }

//   adjustToValidValues(input) {
//     const value = Number(input.value);
//     const min = Number(input.getAttribute('min'));
//     const max = Number(input.getAttribute('max'));

//     if (value < min) input.value = min;
//     if (value > max) input.value = max;
//   }

//   fillSlider () {
//     const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
//     inputRangeWrappers.forEach(inputWrapper => {
//       const inputsRange = inputWrapper.querySelectorAll('.field__range');
//       const inputRangeFrom = inputsRange[0];
//       const inputRangeTo = inputsRange[1];

//       const range = inputRangeTo.max - inputRangeTo.min;
//       const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
//       const toCurrent = inputRangeTo.value - inputRangeTo.min;
//       const minRange = fromCurrent / range * 100;
//       const maxRange = toCurrent / range * 100;

//       inputWrapper.setAttribute(
//         'style',
//         `--range-min: ${minRange}%; --range-max: ${maxRange}%`
//       );
//     })
//   }

//   controlSlider () {
//     const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
//     const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

//     inputRangeWrappers.forEach((inputWrapper, index) => {
//       const inputsRange = inputWrapper.querySelectorAll('.field__range');
//       const inputRangeFrom = inputsRange[0];
//       const inputRangeTo = inputsRange[1];
//       const inputNumberFrom = inputNumberWrappers[index].querySelectorAll('.price-display-input')[0];
//       const inputNumberTo = inputNumberWrappers[index].querySelectorAll('.price-display-input')[1];
//       const hiddenInputMin = inputNumberWrappers[index].querySelectorAll('.price-hidden-input')[0];
//       const hiddenInputMax = inputNumberWrappers[index].querySelectorAll('.price-hidden-input')[1];

//       inputRangeFrom.oninput = () => {
//         const from = parseInt(inputRangeFrom.value, 10);
//         const to = parseInt(inputRangeTo.value, 10);
//         if (from > to) {
//           inputRangeFrom.value = to;
//           if (inputNumberFrom) inputNumberFrom.value = to;
//           if (hiddenInputMin) hiddenInputMin.value = to * 100;
//         }
//         else {
//           if (inputNumberFrom) inputNumberFrom.value = from;
//           if (hiddenInputMin) hiddenInputMin.value = from * 100;
//         }

//         this.fillSlider();
//       }

//       if (Number(inputRangeTo.value) <= 0 ) {
//         inputRangeTo.style.zIndex = 2;
//       } else {
//         inputRangeTo.style.zIndex = 0;
//       }

//       inputRangeTo.oninput = () => {
//         const from = parseInt(inputRangeFrom.value, 10);
//         const to = parseInt(inputRangeTo.value, 10);
//         if (from <= to) {
//           inputRangeTo.value = to;
//           if (inputNumberTo) inputNumberTo.value = to;
//           if (hiddenInputMax) hiddenInputMax.value = to * 100;
//         }
//         else {
//           if (inputNumberTo) inputNumberTo.value = from;
//           if (hiddenInputMax) hiddenInputMax.value = from * 100;
//           inputRangeTo.value = from;
//         }

//         if (Number(inputRangeTo.value) <= 0 ) {
//           inputRangeTo.style.zIndex = 2;
//         } else {
//           inputRangeTo.style.zIndex = 0;
//         }

//         this.fillSlider();
//       }
//     })
//   }

//   controlInput() {
//     const inputRangeWrappers = document.querySelectorAll('.facets__price .facets__range');
//     const inputNumberWrappers = document.querySelectorAll('.facets__price .facets__price-wrapper');

//     inputNumberWrappers.forEach((inputWrapper, index) => {
//       const inputsNumber = inputWrapper.querySelectorAll('.price-display-input');
//       const inputNumberFrom = inputsNumber[0];
//       const inputNumberTo = inputsNumber[1];
//       const hiddenInputMin = inputWrapper.querySelectorAll('.price-hidden-input')[0];
//       const hiddenInputMax = inputWrapper.querySelectorAll('.price-hidden-input')[1];
//       const inputRangeFrom = inputRangeWrappers[index] ? inputRangeWrappers[index].querySelectorAll('.field__range')[0] : null;
//       const inputRangeTo = inputRangeWrappers[index] ? inputRangeWrappers[index].querySelectorAll('.field__range')[1] : null;

//       if (inputNumberFrom) {
//         inputNumberFrom.oninput = () => {
//           const from = parseInt(inputNumberFrom.value, 10) || 0;
//           const to = parseInt(inputNumberTo ? inputNumberTo.value : 0, 10) || 0;
//           if (from > to && to > 0) {
//             if (inputRangeFrom) inputRangeFrom.value = to;
//             inputNumberFrom.value = to;
//             if (hiddenInputMin) hiddenInputMin.value = to * 100;
//           }
//           else {
//             if (inputRangeFrom) inputRangeFrom.value = from;
//             if (hiddenInputMin) hiddenInputMin.value = from * 100;
//           }

//           this.fillSlider();
//         }
//       }

//       if (inputNumberTo) {
//         inputNumberTo.oninput = () => {
//           const from = parseInt(inputNumberFrom ? inputNumberFrom.value : 0, 10) || 0;
//           const to = parseInt(inputNumberTo.value, 10) || 0;
//           if (from <= to) {
//             if (inputRangeTo) inputRangeTo.value = to;
//             inputNumberTo.value = to;
//             if (hiddenInputMax) hiddenInputMax.value = to * 100;
//           }
//           else {
//             inputNumberTo.value = from;
//             if (hiddenInputMax) hiddenInputMax.value = from * 100;
//           }

//           this.fillSlider();
//         }
//       }

//     })
//   }
// }

// customElements.define('price-range', PriceRange);

// class FacetRemove extends HTMLElement {
//   constructor() {
//     super();
//     const facetLink = this.querySelector('a');
//     facetLink.setAttribute('role', 'button');
//     facetLink.addEventListener('click', this.closeFilter.bind(this));
//     facetLink.addEventListener('keyup', (event) => {
//       event.preventDefault();
//       if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
//     });
//   }

//   closeFilter(event) {
//     event.preventDefault();
//     const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
//     form.onActiveFilterClick(event);
//   }
// }

// customElements.define('facet-remove', FacetRemove);

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector("form") || this.closest("form");

    if (!facetForm) {
      console.warn("No form found in FacetFiltersForm");
      return;
    }

    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    // Immediate visual feedback for checkboxes
    facetForm.addEventListener("change", (event) => {
      if (event.target.type === "checkbox") {
        // Sync same-named checkboxes across all forms immediately
        const paramName = event.target.name;
        const paramValue = event.target.value;
        const isChecked = event.target.checked;

        document
          .querySelectorAll(
            `input[type="checkbox"][name="${paramName}"][value="${paramValue}"]`,
          )
          .forEach((checkbox) => {
            if (checkbox !== event.target) {
              checkbox.checked = isChecked;
            }
          });
      }
    });

    // Price display input sync with hidden input
    this.initPriceInputSync();

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) {
      facetWrapper.addEventListener("keyup", onKeyUpEscape);
    }

    // Open all details on wide screens
    this.openDetailsOnWideScreen();
  }

  openDetailsOnWideScreen() {
    // Check if on desktop (>768px)
    const mediaQuery = window.matchMedia("(min-width: 769px)");

    const openAllDetails = () => {
      if (mediaQuery.matches) {
        // Desktop: open all details
        this.querySelectorAll(
          "details.disclosure-has-popup.facets__disclosure",
        ).forEach((detail) => {
          detail.setAttribute("open", "");
        });
      } else {
        // Mobile: close all details
        this.querySelectorAll(
          "details.disclosure-has-popup.facets__disclosure",
        ).forEach((detail) => {
          detail.removeAttribute("open");
        });
      }
    };

    // Initial check
    openAllDetails();

    // Listen for window resize
    mediaQuery.addListener(openAllDetails);
  }

  initPriceInputSync() {
    const priceDisplayInputs = this.querySelectorAll(".price-display-input");
    priceDisplayInputs.forEach((input) => {
      input.addEventListener("input", (e) => {
        // Find hidden input - it should be a sibling or in the same parent
        let hiddenInput = e.target.parentElement.querySelector(
          ".price-hidden-input",
        );
        if (!hiddenInput) {
          // If not in parent, check next element or look in price-range element
          hiddenInput = e.target
            .closest("price-range")
            .querySelector(
              `.price-hidden-input[name="${e.target.dataset.paramName}"]`,
            );
        }
        if (hiddenInput) {
          // Convert display value (dollars) to cents for Shopify
          const displayValue = parseFloat(e.target.value) || 0;
          hiddenInput.value = Math.round(displayValue * 100);
        }
      });
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;
    if (
      document.querySelector(".js-load-more") ||
      document.querySelector(".js-infinite-scroll")
    )
      loadMore();

    colorSwatches();
  }

  static renderProductCount(html) {
    const parsedHtml = new DOMParser().parseFromString(html, "text/html");
    const countElement = parsedHtml.getElementById("ProductCount");
    if (!countElement) return;

    const count = countElement.innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");

    if (container) {
      container.innerHTML = count;
      container.classList.remove("loading");
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element),
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    // Update all matching elements (both desktop and mobile)
    facetsToRender.forEach((element) => {
      const matchingElements = document.querySelectorAll(
        `.js-filter[data-index="${element.dataset.index}"]`,
      );
      matchingElements.forEach((targetElement) => {
        targetElement.innerHTML = element.innerHTML;
      });
    });

    // Re-initialize price input sync after DOM update
    FacetFiltersForm.reinitPriceInputSync();

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender)
      FacetFiltersForm.renderCounts(
        countsToRender,
        event.target.closest(".js-filter"),
      );
  }

  static reinitPriceInputSync() {
    document.querySelectorAll("facet-filters-form").forEach((form) => {
      const priceDisplayInputs = form.querySelectorAll(".price-display-input");
      priceDisplayInputs.forEach((input) => {
        // Remove old listeners by cloning
        const newInput = input.cloneNode(true);
        input.parentNode.replaceChild(newInput, input);

        newInput.addEventListener("input", (e) => {
          // Find hidden input - it should be a sibling or in the same parent
          let hiddenInput = e.target.parentElement.querySelector(
            ".price-hidden-input",
          );
          if (!hiddenInput) {
            // If not in parent, check in price-range element
            hiddenInput = e.target
              .closest("price-range")
              .querySelector(
                `.price-hidden-input[name="${e.target.dataset.paramName}"]`,
              );
          }
          if (hiddenInput) {
            const displayValue = parseFloat(e.target.value) || 0;
            hiddenInput.value = Math.round(displayValue * 100);
          }
        });
      });
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById("FacetFiltersFormMobile");
    if (mobileForm) {
      const menuDrawer = mobileForm.closest("menu-drawer");
      if (menuDrawer && typeof menuDrawer.bindEvents === "function") {
        menuDrawer.bindEvents();
      }
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    const targetElementAccessibility = target.querySelector(".facets__summary");
    const sourceElementAccessibility = source.querySelector(".facets__summary");

    if (sourceElement && targetElement) {
      target.querySelector(".facets__selected").outerHTML =
        source.querySelector(".facets__selected").outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector(".facets__summary").outerHTML =
        source.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );
    if (event.srcElement.className == "mobile-facets__checkbox") {
      const searchParams = this.createSearchParams(
        event.target.closest("form"),
      );
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const currentFormId = event.target.closest("form").id;
      const isMobile = currentFormId === "FacetFiltersFormMobile";

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (
            form.id === "FacetSortForm" ||
            form.id === "FacetFiltersForm" ||
            form.id === "FacetSortDrawerForm" ||
            form.id === "FacetFiltersFormDesktop"
          ) {
            const noJsElements = document.querySelectorAll(".no-js-list");
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === "FacetFiltersFormMobile") {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join("&"), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this)),
    );
    this.setMinAndMaxValues();
    this.controlSlider();
    this.controlInput();
    /* Bundle fiyat düzeltmesini DOM ve inline script'ler hazır olunca çalıştır */
    const self = this;
    const tryAdjust = function() {
      if (Object.keys(window.bundleProductsMap || {}).length > 0) {
        self.adjustMaxForBundles();
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(tryAdjust, 50);
      });
    } else {
      setTimeout(tryAdjust, 100);
      setTimeout(tryAdjust, 500);
    }
  }

  adjustMaxForBundles() {
    const map = window.bundleProductsMap || {};
    if (Object.keys(map).length === 0) return;

    /* Her bundle ürünün toplam fiyatını hesapla, en yükseğini bul */
    const seen = new Set();
    let highestBundlePrice = 0;

    Object.keys(map).forEach(function(vid) {
      const b = map[vid];
      const key = b.productId || vid;
      if (seen.has(key)) return;
      seen.add(key);

      let total = 0;
      if (b.requiredItems && b.requiredItems.length) {
        b.requiredItems.forEach(function(req) {
          total += (req.price || 0);
        });
      }
      if (total > highestBundlePrice) highestBundlePrice = total;
    });

    if (highestBundlePrice <= 0) return;

    /* Shopify fiyatları cent cinsinden, TL'ye çevir */
    const highestPriceTL = Math.ceil(highestBundlePrice / 100);

    /* Mevcut max değerini bul */
    const rangeInputs = this.querySelectorAll('input[type="range"]');
    const numberInputs = this.querySelectorAll('input[type="number"]');
    const maxInput = numberInputs[1] || rangeInputs[1];
    if (!maxInput) return;

    const currentMax = parseInt(maxInput.getAttribute("max"), 10) || 0;

    if (highestPriceTL <= currentMax) return;

    /* Tüm ilgili input'ların max değerini güncelle */
    rangeInputs.forEach(function(inp) {
      inp.setAttribute("max", highestPriceTL);
    });
    numberInputs.forEach(function(inp) {
      if (inp.getAttribute("id") && inp.getAttribute("id").includes("LTE")) {
        inp.setAttribute("max", highestPriceTL);
        /* Eğer kullanıcı henüz filtrelemedi ise placeholder ve değeri de güncelle */
        if (!inp.value || parseInt(inp.value, 10) === currentMax) {
          inp.value = highestPriceTL;
          inp.setAttribute("placeholder", highestPriceTL);
        }
      } else {
        inp.setAttribute("max", highestPriceTL);
      }
    });

    /* Hidden input'u da güncelle (max value - cent cinsinden) */
    const hiddenMax = this.querySelector('.price-hidden-input:last-of-type') ||
      this.closest('.facets__price')?.querySelectorAll('.price-hidden-input')[1];
    if (hiddenMax && (!hiddenMax.value || parseInt(hiddenMax.value, 10) === currentMax * 100)) {
      hiddenMax.value = highestPriceTL * 100;
    }

    /* Range slider'ın to değerini de güncelle */
    if (rangeInputs[1]) {
      const currentRangeVal = parseInt(rangeInputs[1].value, 10);
      if (currentRangeVal === currentMax) {
        rangeInputs[1].value = highestPriceTL;
      }
    }

    /* Fiyat etiketini güncelle */
    const priceLabel = this.querySelector('.facets__price-label');
    if (priceLabel) {
      const currentText = priceLabel.textContent;
      /* Mevcut max fiyat metnini yenisiyle değiştir */
      const formattedOld = currentMax.toLocaleString('tr-TR', { minimumFractionDigits: 2 });
      const formattedNew = highestPriceTL.toLocaleString('tr-TR', { minimumFractionDigits: 2 });
      if (currentText.includes(formattedOld)) {
        priceLabel.textContent = currentText.replace(formattedOld, formattedNew);
      }
    }

    /* Slider'ı yeni max değerine göre yeniden çiz */
    this.fillSlider();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  fillSlider() {
    const inputRangeWrappers = document.querySelectorAll(
      ".facets__price .facets__range",
    );
    inputRangeWrappers.forEach((inputWrapper) => {
      const inputsRange = inputWrapper.querySelectorAll(".field__range");
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];

      const range = inputRangeTo.max - inputRangeTo.min;
      const fromCurrent = inputRangeFrom.value - inputRangeTo.min;
      const toCurrent = inputRangeTo.value - inputRangeTo.min;
      const minRange = (fromCurrent / range) * 100;
      const maxRange = (toCurrent / range) * 100;

      inputWrapper.setAttribute(
        "style",
        `--range-min: ${minRange}%; --range-max: ${maxRange}%`,
      );
    });
  }

  controlSlider() {
    const inputRangeWrappers = document.querySelectorAll(
      ".facets__price .facets__range",
    );
    const inputNumberWrappers = document.querySelectorAll(
      ".facets__price .facets__price-wrapper",
    );

    inputRangeWrappers.forEach((inputWrapper, index) => {
      const inputsRange = inputWrapper.querySelectorAll(".field__range");
      const inputRangeFrom = inputsRange[0];
      const inputRangeTo = inputsRange[1];
      const inputNumberFrom = inputNumberWrappers[index].querySelectorAll(
        ".price-display-input",
      )[0];
      const inputNumberTo = inputNumberWrappers[index].querySelectorAll(
        ".price-display-input",
      )[1];
      const hiddenInputMin = inputNumberWrappers[index].querySelectorAll(
        ".price-hidden-input",
      )[0];
      const hiddenInputMax = inputNumberWrappers[index].querySelectorAll(
        ".price-hidden-input",
      )[1];

      inputRangeFrom.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from > to) {
          inputRangeFrom.value = to;
          if (inputNumberFrom) inputNumberFrom.value = to;
          if (hiddenInputMin) hiddenInputMin.value = to * 100;
        } else {
          if (inputNumberFrom) inputNumberFrom.value = from;
          if (hiddenInputMin) hiddenInputMin.value = from * 100;
        }

        this.fillSlider();
      };

      if (Number(inputRangeTo.value) <= 0) {
        inputRangeTo.style.zIndex = 2;
      } else {
        inputRangeTo.style.zIndex = 0;
      }

      inputRangeTo.oninput = () => {
        const from = parseInt(inputRangeFrom.value, 10);
        const to = parseInt(inputRangeTo.value, 10);
        if (from <= to) {
          inputRangeTo.value = to;
          if (inputNumberTo) inputNumberTo.value = to;
          if (hiddenInputMax) hiddenInputMax.value = to * 100;
        } else {
          if (inputNumberTo) inputNumberTo.value = from;
          if (hiddenInputMax) hiddenInputMax.value = from * 100;
          inputRangeTo.value = from;
        }

        if (Number(inputRangeTo.value) <= 0) {
          inputRangeTo.style.zIndex = 2;
        } else {
          inputRangeTo.style.zIndex = 0;
        }

        this.fillSlider();
      };
    });
  }

  controlInput() {
    const inputRangeWrappers = document.querySelectorAll(
      ".facets__price .facets__range",
    );
    const inputNumberWrappers = document.querySelectorAll(
      ".facets__price .facets__price-wrapper",
    );

    inputNumberWrappers.forEach((inputWrapper, index) => {
      const inputsNumber = inputWrapper.querySelectorAll(
        ".price-display-input",
      );
      const inputNumberFrom = inputsNumber[0];
      const inputNumberTo = inputsNumber[1];
      const hiddenInputMin = inputWrapper.querySelectorAll(
        ".price-hidden-input",
      )[0];
      const hiddenInputMax = inputWrapper.querySelectorAll(
        ".price-hidden-input",
      )[1];
      const inputRangeFrom = inputRangeWrappers[index]
        ? inputRangeWrappers[index].querySelectorAll(".field__range")[0]
        : null;
      const inputRangeTo = inputRangeWrappers[index]
        ? inputRangeWrappers[index].querySelectorAll(".field__range")[1]
        : null;

      if (inputNumberFrom) {
        inputNumberFrom.oninput = () => {
          const from = parseInt(inputNumberFrom.value, 10) || 0;
          const to = parseInt(inputNumberTo ? inputNumberTo.value : 0, 10) || 0;
          if (from > to && to > 0) {
            if (inputRangeFrom) inputRangeFrom.value = to;
            inputNumberFrom.value = to;
            if (hiddenInputMin) hiddenInputMin.value = to * 100;
          } else {
            if (inputRangeFrom) inputRangeFrom.value = from;
            if (hiddenInputMin) hiddenInputMin.value = from * 100;
          }

          this.fillSlider();
        };
      }

      if (inputNumberTo) {
        inputNumberTo.oninput = () => {
          const from =
            parseInt(inputNumberFrom ? inputNumberFrom.value : 0, 10) || 0;
          const to = parseInt(inputNumberTo.value, 10) || 0;
          if (from <= to) {
            if (inputRangeTo) inputRangeTo.value = to;
            inputNumberTo.value = to;
            if (hiddenInputMax) hiddenInputMax.value = to * 100;
          } else {
            inputNumberTo.value = from;
            if (hiddenInputMax) hiddenInputMax.value = from * 100;
          }

          this.fillSlider();
        };
      }
    });
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);
